module.exports = __webpack_public_path__ + "static/media/belveb.e8aa4dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belveb.png
// module id = 319
// module chunks = 0